import styled from "styled-components";
import { designTokens, getTypography } from "styles/designTokens";

export const TabsContainer = styled.div`
  display: flex;
  gap: 20px;
`;

export const Tab = styled.button<{ $active: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  gap: 10px;
  background: none;
  border: none;
  cursor: pointer;
  font: inherit;
  outline: inherit;
  font-size: ${getTypography("korean", "title1").fontSize};
  font-weight: ${getTypography("korean", "title1").fontWeight};
  letter-spacing: ${getTypography("korean", "title1").letterSpacing};
  line-height: ${getTypography("korean", "title1").lineHeight};
  color: ${(p) =>
    p.$active
      ? designTokens.colors.font.primary
      : designTokens.colors.font.quinary};

  &:hover {
    color: ${designTokens.colors.font.primary};
  }
`;
